import React, { Component } from "react";
import { v4 as uuidv4 } from "uuid";
import { CardImg, Button, CardTitle, Container } from "reactstrap";
import { Row, Col, Popover } from "antd";
import { Widget, addResponseMessage, renderCustomComponent, toggleWidget, dropMessages, addLinkSnippet } from "react-chat-widget";

import "./styles.css";
import "./chat.style.css";
import "./samard.style.css";
import "./selectchat.style.css";
import "../Feednews/feednews.style.css";
import "axios";
import Axios from "axios";

import QuickReply from "./quickreply";
import logo from "../../assets/chat/smile1.png";
import sandee_ok from "../../assets/chat/sandee_ok.png";
import teamwork_samard from "../../assets/feednews/teamwork_samard.png";
import AIChatbox from "./AIChatbox";
import SAPChangeOwnerChatbox from "./SAPChangeOwnerChatbox";
import GetHelpCxChatbox from "./GetHelpCxChatbox";
import UnlockResetByItOneCxChatBox from "./UnlockResetByItOneCxChatBox";
import UnlockResetAD from "./UnlockResetAD";
import UnlockResetSAP from "./UnlockResetSAP";
import Ariba from "./Ariba";
import guide_book from "../../assets/feednews/guide_book.png";
import sandeeUpdate from "../../assets/feednews/sandee_ai.png";
import checkMark from "../../assets/feednews/CheckMark.png";
import information from "../../assets/chat/i_purple.gif";
import { validateADPassword } from "./ADPasswordPolicy";
import { LanguageContext } from "../../context/LanguageContext";
import { getText } from "../configure/utils";
import { getLoading, pageConfig } from "../configure/page";

// Map components to their names as strings
const componentMap = {
  AIChatbox: AIChatbox,
  SAPChangeOwnerChatbox: SAPChangeOwnerChatbox,
  GetHelpCxChatbox: GetHelpCxChatbox,
  UnlockResetByItOneCxChatBox: UnlockResetByItOneCxChatBox,
  UnlockResetAD: UnlockResetAD,
  UnlockResetSAP: UnlockResetSAP,
  Ariba: Ariba,
};

var session = "";
var action = "";
var json;
var json_csharp;
var blockingState = false;
var lastMessage = false;
var clickEventExist = false;
var lambda_api = "";
var csharp_api = "";
var v_typeofservice = "";
var closesender = false;

class changeMode extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div style={{ color: "#ccc" }}>
        <h6>Start Session {this.props.mode}</h6>
      </div>
    );
  }
}

export default class Chat extends Component {
  static contextType = LanguageContext;
  currentLanguage = null;

  constructor(props) {
    super(props);
    this.state = {
      sateshowflag: false,
      toggleAI: false,
      toggleUnlockResetSAP: false,
      toggleSAPChangeOwner: false,
      toggleGetHelp: false,
      toggleUnlockResetByItOne: false,
      toggleUnlockResetAD: false,
      toggleAriba: false,
      verifyADPass: false,
      preventPaste: false,
    };
    this.menuADClick = this.menuADClick.bind(this);
    this.menuSAPClick = this.menuSAPClick.bind(this);
    this.menuAribaClick = this.menuAribaClick.bind(this);
    this.menuGenAIClick = this.menuGenAIClick.bind(this);
    this.menuSAPChangeOwnerClick = this.menuSAPChangeOwnerClick.bind(this);
    this.menuGetHelpClick = this.menuGetHelpClick.bind(this);
    this.menuUnlockResetByItOneCxClick = this.menuUnlockResetByItOneCxClick.bind(this);
    this.menuSCGARIBAClick = this.menuSCGARIBAClick.bind(this);
    this.handleNewUserMessage = this.handleNewUserMessage.bind(this);
  }

  componentDidMount() {
    this.currentLanguage = this.context.language;
  }

  componentDidUpdate() {
    if (this.context.language !== this.currentLanguage) {
      this.currentLanguage = this.context.language;
    }
  }

  greeting(lambda_api, type) {
    setTimeout(() => {
      var language = this.currentLanguage;

      const chatbox = document.querySelector(".rcw-messages-container");
      if (!chatbox) return;
      if (chatbox.style.position !== "relative") {
        chatbox.style.position = "relative";
      }

      chatbox.appendChild(getLoading());

      closesender = true;
      this.blockUiEvent();

      var json = {
        session: session,
        queryInput: {
          text: {
            text: "greeting",
            languageCode: "en-US",
            typeofservice: type,
          },
        },
      };

      if (language === "th") {
        language = "TH";
      } else if (language === "en") {
        language = "ENG";
      }
      if (lambda_api) {
        (async () => {
          await Axios.post(lambda_api, json).then((response) => {
            let messages = response.data.queryResult.fulfillmentMessages.filter((item) => {
              return item.platform === "PLATFORM_UNSPECIFIED";
            });
            messages.forEach((msg) => {
              let fields = msg.payload.fields;
              if (fields.type.stringValue === "text" && fields.Lang.stringValue === language) {
                addResponseMessage(fields.messages.stringValue);
              }
            });

            const loading = document.querySelector("#chat-loading-overlay");
            if (loading) {
              loading.remove();
            }

            this.unblockUiEvent();
          });
        })();
      }
    }, 200);
  }

  swapflag() {
    this.setState({
      sateshowflag: !this.sateshowflag,
    });
  }

  blockUiEvent() {
    if (lastMessage) {
      setTimeout(() => {
        const sender = document.querySelector(".rcw-new-message");
        const button = document.querySelector(".rcw-send");
        if (!sender && !button) {
          return;
        }
        if (blockingState) {
          if (!sender.hasAttribute("disabled") && !button.hasAttribute("disabled")) {
            sender.setAttribute("disabled", "");
            button.setAttribute("disabled", "");
            document.querySelector(".rcw-messages-container").style.backgroundColor = "#D4D7D9";
            document.querySelector(".rcw-sender").style.backgroundColor = "#D4D7D9";
            document.querySelector(".rcw-new-message").style.backgroundColor = "#D4D7D9";
            document.querySelector(".rcw-send").style.backgroundColor = "#D4D7D9";
          }
        }
      }, 200);
    } else if (closesender) {
      //console.log("I'm here in closesender");
      setTimeout(() => {
        const sender = document.querySelector(".rcw-new-message");
        const button = document.querySelector(".rcw-send");
        if (!sender && !button) {
          return;
        }
        if (!sender.hasAttribute("disabled") && !button.hasAttribute("disabled")) {
          sender.setAttribute("disabled", "");
          button.setAttribute("disabled", "");
        }
      }, 200);
    } else {
      setTimeout(() => {
        const addEventClick = document.querySelector(".rcw-launcher");
        if (!clickEventExist) {
          addEventClick.addEventListener("click", () => {
            clickEventExist = true;
            if (document.getElementsByClassName("rcw-hide-sm").length === 0 && blockingState) {
              setTimeout(() => {
                const sender = document.querySelector(".rcw-new-message");
                const button = document.querySelector(".rcw-send");
                if (!sender && !button) {
                  return;
                }
                if (!sender.hasAttribute("disabled") && !button.hasAttribute("disabled")) {
                  sender.setAttribute("disabled", "");
                  button.setAttribute("disabled", "");
                  document.querySelector(".rcw-messages-container").style.backgroundColor = "#D4D7D9";
                  document.querySelector(".rcw-sender").style.backgroundColor = "#D4D7D9";
                  document.querySelector(".rcw-new-message").style.backgroundColor = "#D4D7D9";
                  document.querySelector(".rcw-send").style.backgroundColor = "#D4D7D9";
                }
              }, 100);
            }
          });
        }
      }, 500);
    }
  }

  unblockUiEvent() {
    setTimeout(() => {
      const sender = document.querySelector(".rcw-new-message");
      const button = document.querySelector(".rcw-send");
      if (!sender && !button) {
        return;
      }
      if (sender.hasAttribute("disabled") && button.hasAttribute("disabled")) {
        sender.removeAttribute("disabled");
        button.removeAttribute("disabled");
      }
      if (!closesender) {
        document.querySelector(".rcw-messages-container").style.backgroundColor = "";
        document.querySelector(".rcw-sender").style.backgroundColor = "";
        document.querySelector(".rcw-new-message").style.backgroundColor = "";
        document.querySelector(".rcw-send").style.backgroundColor = "";
      }
    }, 100);
  }

  menuADClick() {
    if (this.state.toggleUnlockResetAD) {
      const dfMessengerBubble = document.querySelector(".adUnlockReset df-messenger df-messenger-chat-bubble");
      if (dfMessengerBubble) {
        dfMessengerBubble.openChat();
        const event = new CustomEvent("df-ad-clear-chat-session", {
          detail: { message: true },
        });
        window.dispatchEvent(event);
      }
    }

    this.setState({ toggleAI: false, toggleUnlockResetAD: true, toggleAriba: false,  toggleUnlockResetSAP: false, toggleSAPChangeOwner: false, toggleGetHelp: false, toggleUnlockResetByItOne: false });
  }

  menuSAPClick() {
    if (this.state.toggleUnlockResetSAP) {
      const dfMessengerBubble = document.querySelector(".sapUnlockReset df-messenger df-messenger-chat-bubble");
      if (dfMessengerBubble) {
        dfMessengerBubble.openChat();
        const event = new CustomEvent("df-sap-clear-chat-session", {
          detail: { message: true },
        });
        window.dispatchEvent(event);
      }
    }

    this.setState({ toggleAI: false, toggleUnlockResetAD: false, toggleAriba: false,  toggleUnlockResetSAP: true, toggleSAPChangeOwner: false, toggleGetHelp: false, toggleUnlockResetByItOne: false });
  }

  menuAribaClick() {
    if (this.state.toggleAriba) {
      const dfMessengerBubble = document.querySelector(".ariba df-messenger df-messenger-chat-bubble");
      if (dfMessengerBubble) {
        dfMessengerBubble.openChat();
        const event = new CustomEvent("df-ariba-clear-chat-session", {
          detail: { message: true },
        });
        window.dispatchEvent(event);
      }
    }

    this.setState({ toggleAI: false, toggleUnlockResetAD: false, toggleAriba: true, toggleUnlockResetSAP: false, toggleSAPChangeOwner: false, toggleGetHelp: false, toggleUnlockResetByItOne: false });
  }
  // menuSAPClick() {
  //   if (blockingState) {
  //     this.unblockUiEvent();
  //   }
  //   lastMessage = false;
  //   blockingState = false;
  //   closesender = false;
  //   this.swapflag();
  //   dropMessages();
  //   session = uuidv4();
  //   renderCustomComponent(changeMode, { mode: "SAP" }, false);
  //   //set environment
  //   lambda_api = process.env.REACT_APP_LAMBDA_SAP;
  //   csharp_api = process.env.REACT_APP_CSHARP_API_SAP;
  //   v_typeofservice = "SAP";

  //   this.greeting(lambda_api, v_typeofservice);

  //   var hasClass = document.getElementsByClassName("rcw-opened");
  //   if (hasClass.length === 0) {
  //     toggleWidget();
  //   }
  //   this.blockUiEvent();
  // }

  menuGenAIClick() {
    if (this.state.toggleAI) {
      const dfMessengerBubble = document.querySelector("df-messenger-chat-bubble");
      if (dfMessengerBubble) {
        dfMessengerBubble.openChat();
        const event = new CustomEvent("df-genai-clear-chat-session", {
          detail: { message: true },
        });
        window.dispatchEvent(event);
      }
    }

    this.setState({ toggleAI: true, toggleUnlockResetAD: false, toggleAriba: false,  toggleUnlockResetSAP: false, toggleSAPChangeOwner: false, toggleGetHelp: false, toggleUnlockResetByItOne: false });
  }

  menuSAPChangeOwnerClick() {
    if (this.state.toggleSAPChangeOwner) {
      const dfMessengerBubble = document.querySelector("df-messenger-chat-bubble");
      if (dfMessengerBubble) {
        dfMessengerBubble.openChat();
        const event = new CustomEvent("df-sapchangeowner-clear-chat-session", {
          detail: { message: true },
        });
        window.dispatchEvent(event);
      }
    }

    this.setState({ toggleSAPChangeOwner: true, toggleAI: false, toggleAriba: false,  toggleUnlockResetSAP: false, toggleUnlockResetAD: false, toggleGetHelp: false, toggleUnlockResetByItOne: false });
  }

  menuGetHelpClick() {
    if (this.state.toggleGetHelp) {
      const dfMessengerBubble = document.querySelector("df-messenger-chat-bubble");
      if (dfMessengerBubble) {
        dfMessengerBubble.openChat();
        const event = new CustomEvent("df-gethelp-clear-chat-session", {
          detail: { message: true },
        });
        window.dispatchEvent(event);
      }
    }

    this.setState({ toggleSAPChangeOwner: false, toggleAI: false, toggleAriba: false,  toggleUnlockResetSAP: false, toggleUnlockResetAD: false, toggleGetHelp: true, toggleUnlockResetByItOne: false });
  }

  menuUnlockResetByItOneCxClick() {
    if (this.state.toggleUnlockResetByItOne) {
      const dfMessengerBubble = document.querySelector("df-messenger-chat-bubble");
      if (dfMessengerBubble) {
        dfMessengerBubble.openChat();
        const event = new CustomEvent("df-unlock-reset-clear-chat-session", {
          detail: { message: true },
        });
        window.dispatchEvent(event);
      }
    }

    this.setState({ toggleSAPChangeOwner: false, toggleAI: false, toggleAriba: false,  toggleUnlockResetSAP: false, toggleUnlockResetAD: false, toggleGetHelp: false, toggleUnlockResetByItOne: true });
  }

  menuSCGARIBAClick() {
    if (blockingState) {
      this.unblockUiEvent();
    }
    lastMessage = false;
    blockingState = false;
    closesender = false;
    this.swapflag();
    dropMessages();
    session = uuidv4();
    renderCustomComponent(changeMode, { mode: "SANDEE : SAP Ariba Sourcing" }, false);
    //set environment
    lambda_api = process.env.REACT_APP_LAMBDA_SCGARIBA;
    csharp_api = process.env.REACT_APP_CSHARP_API_SCGARIBA;
    v_typeofservice = "SCGP";

    this.greeting(lambda_api, v_typeofservice);

    var hasClass = document.getElementsByClassName("rcw-opened");
    if (hasClass.length === 0) {
      toggleWidget();
    }
    this.blockUiEvent();
  }

  checkIntentForBlockUI(msg) {
    switch (msg) {
      case "Report Problem Completed":
        return true;
      case "8.2 SurveyCompleted":
        return true;
      case "Survey":
        return true;
      case "Case Opened":
        return true;
      case "Default Fallback Intent":
        return true;
      case "Report Requested Completed":
        return true;
      case "Report Problem UnCompleted":
        return true;
      case "5.3 OTP Expired":
        return true;
      case "Error":
        return true;

      default:
        return false;
    }
  }

  async handleNewUserMessage(newMessage) {
    closesender = true;
    var language = this.currentLanguage;
    if (language === "th") {
      language = "TH";
    } else if (language === "en") {
      language = "ENG";
    }

    if (closesender && !this.state.verifyADPass) {
      this.blockUiEvent();
    }
    const ADPasswordPolicy = ({ message }) => {
      return (
        <div class="rcw-message margin">
          <img src="/static/media/smile1.3b51dab9.png" class="rcw-avatar" alt="profile"></img>
          <div class="rcw-response">
            <div class="rcw-message-text" dangerouslySetInnerHTML={{ __html: message }} />
          </div>
        </div>
      );
    };

    if (this.state.verifyADPass) {
      var message = validateADPassword(newMessage.trim(), language);
      if (message) {
        // addResponseMessage(message);
        renderCustomComponent(ADPasswordPolicy, { message: message });
        addResponseMessage(language === "ENG" ? "Please specify your password again." : "รบกวนระบุรหัสผ่านใหม่อีกครั้งค่ะ");
        return;
      }
      this.setState({ verifyADPass: false });
    }

    //request api controller
    json = {
      session: session,
      queryInput: {
        text: {
          text: newMessage,
          languageCode: "en-US",
          typeofservice: v_typeofservice,
        },
      },
    };
    let response = await Axios.post(lambda_api, json);
    //console.log(response);
    action = response.data.queryResult.action;
    if (action != null && action != undefined && action != "" && newMessage != "Greeting" && action != "input.unknown") {
      json_csharp = response.data;
      let response_csharp = await Axios.post(csharp_api, json_csharp);
      // console.log(response_csharp)

      if (response_csharp.data.jobject) {
        json = {
          session: session,
          queryInput: {
            event: response_csharp.data.jobject.followupEventInput,
          },
        };
      } else {
        json = {
          session: session,
          queryInput: {
            event: response_csharp.data.data.followupEventInput,
          },
        };
      }

      response = await Axios.post(lambda_api, json);
      // console.log(response);
      //blockingUI
      if (closesender) {
        this.unblockUiEvent();
      }

      let messages = response.data.queryResult.fulfillmentMessages.filter((item) => {
        return item.platform === "PLATFORM_UNSPECIFIED";
      });
      messages.forEach((msg) => {
        let fields = msg.payload.fields;
        if (fields.type.stringValue === "quick_replies") {
          // this.selectChoice(msg);
          let params = {};
          // params.this  = self;
          params.title = fields.title.stringValue;
          params.newMessage = this.handleNewUserMessage;
          params.buttons = [];
          for (let item of fields.quick_replies.listValue.values) {
            params.buttons.push(item.stringValue);
          }
          closesender = true;
          this.blockUiEvent();
          renderCustomComponent(QuickReply, params, true);
        } else if (fields.type.stringValue === "text" && fields.Lang.stringValue === language) {
          addResponseMessage(fields.messages.stringValue);
          if (fields.hasOwnProperty("mode")) {
            if (fields.mode.stringValue === "validate-pass") {
              this.setState({ verifyADPass: true });
            }
          }
          if (fields.hasOwnProperty("disablePaste")) {
            if (fields.disablePaste.stringValue === "true") {
              if (!this.state.preventPaste) {
                this.disablePasteAndDrop(true);
                this.setState({ preventPaste: true });
              }
            } else {
              if (this.state.preventPaste) {
                this.disablePasteAndDrop(false);
                this.setState({ preventPaste: false });
              }
            }
          }
        } else if (fields.type.stringValue === "link") {
          addLinkSnippet({
            title: "",
            link: fields.messages.stringValue,
            target: "_blank",
          });
        }
      });

      if (this.checkIntentForBlockUI(response.data.queryResult.intent.displayName)) {
        blockingState = true;
        lastMessage = true;
        closesender = false;
        this.blockUiEvent();
      }
    } else {
      //BLockingUI
      if (closesender) {
        this.unblockUiEvent();
      }

      let messages = response.data.queryResult.fulfillmentMessages.filter((item) => {
        return item.platform === "PLATFORM_UNSPECIFIED";
      });
      messages.forEach((msg) => {
        let fields = msg.payload.fields;
        if (fields.type.stringValue === "quick_replies") {
          // this.selectChoice(msg);
          let params = {};
          // params.this  = self;
          params.title = fields.title.stringValue;
          params.newMessage = this.handleNewUserMessage;
          params.buttons = [];
          for (let item of fields.quick_replies.listValue.values) {
            params.buttons.push(item.stringValue);
          }
          closesender = true;
          this.blockUiEvent();
          renderCustomComponent(QuickReply, params, true);
        } else if (fields.type.stringValue === "text" && fields.Lang.stringValue === language) {
          addResponseMessage(fields.messages.stringValue);
          if (fields.hasOwnProperty("mode")) {
            if (fields.mode.stringValue === "validate-pass") {
              this.setState({ verifyADPass: true });
            }
          }
          if (fields.hasOwnProperty("disablePaste")) {
            if (fields.disablePaste.stringValue === "true") {
              if (!this.state.preventPaste) {
                this.disablePasteAndDrop(true);
                this.setState({ preventPaste: true });
              }
            } else {
              if (this.state.preventPaste) {
                this.disablePasteAndDrop(false);
                this.setState({ preventPaste: false });
              }
            }
          }
        } else if (fields.type.stringValue === "link") {
          addLinkSnippet({
            title: "",
            link: fields.messages.stringValue,
            target: "_blank",
          });
        }
      });

      if (this.checkIntentForBlockUI(response.data.queryResult.intent.displayName)) {
        blockingState = true;
        lastMessage = true;
        closesender = false;
        this.blockUiEvent();
      }
    }
  }

  disablePasteAndDrop(bool) {
    var query = document.querySelector(".rcw-new-message");
    if (bool) {
      if (query) {
        query.setAttribute("onpaste", "return false;");
        query.setAttribute("ondragover", "return false;");
        query.setAttribute("ondrop", "return false;");
      }
    } else {
      if (query) {
        query.removeAttribute("onpaste");
        query.removeAttribute("ondragover");
        query.removeAttribute("ondrop");
      }
    }
  }

  disablePasteAndDropEvent() {
    setTimeout(() => {
      const addEventClick1 = document.querySelector(".rcw-launcher");
      if (addEventClick1) {
        addEventClick1.addEventListener("click", () => {
          if (this.state.preventPaste) {
            setTimeout(() => {
              var query = document.querySelector(".rcw-new-message");
              if (query) {
                query.setAttribute("onpaste", "return false;");
                query.setAttribute("ondragover", "return false;");
                query.setAttribute("ondrop", "return false;");
              }
            }, 500);
          }
        });
      }
    }, 500);
  }

  render() {
    const { getHowGoodChatWithSandee, getSelectChat, getAnnouncement } = pageConfig();

    return (
      <div className="sandee-container">
        <section className="box-2">
          <div className="newsamardcard1">
            <div className="cardSamard">
              <Button
                className="buttonClass"
                color="none"
                href="https://sandee-samard.scg.com"
                alt="sandee-samard.scg.com"
                rel="noopener noreferrer"
                target="_blank"
              >
                <Row className="rowSamard">
                  <Col
                    style={{ alignItems: "center" }}
                    xs={{ span: 6 }}
                    sm={{ span: 6 }}
                    md={{ span: 6 }}
                    lg={{ span: 6 }}
                    xl={{ span: 10 }}
                    xxl={{ span: 10 }}
                  >
                    <CardImg src={teamwork_samard} className="samardTeamwork" />
                  </Col>
                  <Col xs={{ span: 18 }} sm={{ span: 18 }} md={{ span: 18 }} lg={{ span: 18 }} xl={{ span: 14 }} xxl={{ span: 14 }}>
                    <CardTitle className="card-title-samard">
                      <p className="samardTitleNameStyle athiti-bold">Samard-Fix Self Service</p>
                      <div className="Samard_textStyle">
                        <p>{getText("samard.detail")}</p>
                      </div>

                      <div className="clickHere athiti-bold">
                        <a href="https://sandee-samard.scg.com" rel="noopener noreferrer" target="_blank">
                          {getText("samard.click")}
                        </a>
                      </div>
                    </CardTitle>
                  </Col>
                </Row>
              </Button>
            </div>
          </div>
        </section>

        <section className="box-1">
          <div className="newfeaturecard">
            <Row className="feedNews athiti-bold">NEWS FEED</Row>
            <Row className="articleStyle">
              <Col style={{ alignItems: "center" }} xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 4 }}>
                <CardImg src={sandeeUpdate} className="newUpdate" />
              </Col>
              <Col xs={{ span: 18 }} sm={{ span: 18 }} md={{ span: 18 }} lg={{ span: 18 }} xl={{ span: 20 }}>
                <CardTitle className="titleNameStyle athiti-bold">
                  <div className="newFeatureTextStyle">
                    <p className="blick-button athiti-bold">ASK! SANDEE AI New Feature</p>
                  </div>
                  <p className="newFeatureTextStyleTitle">
                    <b>{getText("sandee_helping.head")}</b>
                  </p>
                  {getText("sandee_helping.content").map((text, index) => (
                    <div key={index} style={{ display: "flex", alignItems: "center" }}>
                      <img src={checkMark} alt="checkMark" width={30} />
                      <p className="newFeatureTextStyle blackText">{text}</p>
                    </div>
                  ))}
                  <div className="line"></div>

                  <br />

                  <p className="newFeatureTextStyleTitle">
                    <b>{getText("how_good.head")}</b>
                  </p>
                  {getHowGoodChatWithSandee().map((item, index) => (
                    <div key={index} style={{ display: "flex", alignItems: "center" }}>
                      <img src={item.imgSrc} alt={`icon-${index}`} width={30} />
                      <p className="newFeatureTextStyle blackText">{item.text}</p>
                    </div>
                  ))}
                </CardTitle>
              </Col>
            </Row>

            {getAnnouncement(this.currentLanguage).map((item, index) => (
              <Row key={index} className="articleStyle">
                <Col xs={{ span: 6 }} sm={{ span: 6 }} md={{ span: 6 }} lg={{ span: 6 }} xl={{ span: 4 }}>
                  <CardImg src={item.imageSrc} width={item.width} className="imageStyle" />
                </Col>
                <Col xs={{ span: 18 }} sm={{ span: 18 }} md={{ span: 18 }} lg={{ span: 18 }} xl={{ span: 20 }}>
                  {" "}
                  <CardTitle className="announceLayout">
                    <CardTitle className="newFeatureTextStyleTitle athiti-bold">
                      {item.title}
                      <p className="newFeatureTextStyle blackText">{item.disscription}</p>
                      <div className="readMore athiti-bold">
                        <a href={item.href} rel="noopener noreferrer" target="_blank">
                          {item.click}
                        </a>
                      </div>
                    </CardTitle>
                  </CardTitle>
                </Col>
              </Row>
            ))}
          </div>
        </section>

        <section className="box-3">
          <div className="cardSelectChat">
            <CardTitle className="bannerSelectChat athiti-bold">
              <b>SANDEE</b>
            </CardTitle>
            <div className="contrainer-chat">
              {getSelectChat(this.currentLanguage).map((chatItem, index) => {
                const ConditionComponent = componentMap[chatItem.conditionComponent];
                // const content = index === 0 && (
                //   <div>
                //     {chatItem.content.map((item, index) => (
                //       <div key={index} style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
                //         <img src={checkMark} alt="checkMark" width={30} />
                //         <p className="newFeatureTextStyle blackText" style={{ marginLeft: "10px" }}>
                //           {item}
                //         </p>
                //       </div>
                //     ))}
                //   </div>
                // );

                const title = index === 0 && (
                  <p className="chatbot-Wel-Message">
                    <b>&emsp;Sandee Chatbot</b> {getText("welcome1")}
                    <p className="tab">{getText("welcome2")}</p>
                    {/* <b>{chatItem.title}</b> */}
                  </p>
                );

                return (
                  <Row key={index} className={`rowSelectChatStyle ${chatItem.chatColor}`}>
                    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 20 }} lg={{ span: 20 }} xl={{ span: 24 }} xxl={{ span: 24 }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <div className="balloon">
                          <CardImg className="imageSelectChatStyle" src={chatItem.imageSrc} />
                        </div>
                        <Button className={`buttonSelectChatStyle ${chatItem.buttonClass}`} value={chatItem.buttonValue} onClick={this[chatItem.onClick]}>
                          <p className="textSelectChat">{chatItem.buttonText}</p>
                        </Button>
                        {this.state[chatItem.conditionKey] && ConditionComponent && <ConditionComponent />}

                        {index === 0 && ( //display แค่ index แรก
                          <Popover
                            overlayClassName="responsive-popover"
                            // placement="topLeft"
                            title={title}
                            // content={content}
                            trigger="hover"
                          >
                            <Button color="none">
                              <img src={information} alt="information" width={40} />
                            </Button>
                          </Popover>
                        )}

                        {index !== 0 && ( //ไม่ใช่ index แรก จะล่องหน
                          <Popover
                            // placement="topLeft"
                            title={title}
                            // content={content}
                          >
                            <Button color="none" style={{ opacity: 0, cursor: "default" }}>
                              <img src={information} alt="information" width={40} />
                            </Button>
                          </Popover>
                        )}
                      </div>
                    </Col>
                  </Row>
                );
              })}
            </div>
            <div className="SANDEE-UserManual">
              <Row>
                <Col span={24}>
                  <img className="imgBook-SANDEE-UserManual" src={guide_book} width={30}></img>
                  <a
                    href="https://scg.service-now.com/myrequestscg?id=u_kb_article&sys_id=92ab3ba4db241450c48ef0eb0c9619b1"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    วิธีการ Unlock & Reset
                  </a>
                </Col>
              </Row>
            </div>
            <Container>
              <img alt="" className="SandeeOK" src={sandee_ok} />
            </Container>

            <div>
              {this.state.sateshowflag ? (
                <div>
                  <Widget
                    handleNewUserMessage={this.handleNewUserMessage}
                    profileAvatar={logo}
                    title="SANDEE Chatbot"
                    subtitle=""
                    senderPlaceHolder={getText("placeholdertext")}
                    menuSAPClick={this.menuSAPClick}
                    menuSCGARIBAClick={this.menuSCGARIBAClick}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </section>
      </div>
    );
  }
}
